import styled from "styled-components"

export const SocialLinksWrapper = styled.nav`
  margin: 0.5em auto;
  width: 100%;
`
export const SocialLinksList = styled.ul`
  align-items: center;
  display: flex;
  justify-content: space-between;
  list-style: none;
`
export const SocialLinksItem = styled.li``

export const SocialLinksLink = styled.a`
  color: #8899a6;
  text-decoration: none;
  transition: color 0.5s;

  &:hover {
    color: ${props => props.theme.colors.highlight};
  }
`
export const IconWrapper = styled.div`
  background-color: #666;
  border-radius: 50%;
  color: #fff;
  opacity: 0.9;
  padding: 0 0 0.25em;
  width: 1.8em;
  height: 1.8em;

  &:hover {
    background-color: #333;
    opacity: 1;
  }

  svg {
    width: 1.4em;
    height: 1.4em;
  }
`
